import { render } from "./CompetitionCard.vue?vue&type=template&id=91ce5766&scoped=true"
import script from "./CompetitionCard.vue?vue&type=script&lang=js"
export * from "./CompetitionCard.vue?vue&type=script&lang=js"

import "./CompetitionCard.vue?vue&type=style&index=0&id=91ce5766&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ce5766"]])

export default __exports__